<div id="tituloPaginaValePresente" class="app-titulo-pagina visible-xs">
    <span>Vales Presentes</span>
</div>

<div class="col-xs-12 app-banner" style="margin-top: 25px;">
    <img class="hidden-xs" src="assets/img/banners/vale_presente.png" alt="Banner">
    <img class="visible-xs" src="../../assets/img/banners/mobile_vale_presente.png" alt="Banner Vale Presente">
</div>

<a (click)="novo()" *ngIf="!this.mainService.valePresenteCestaService.itens.length" class="btn app-btn-best-v2"
    id="novo-vale" style="margin-bottom: 50px;">
    <i class="fa fa-plus-circle"></i> Novo Resgate
</a>
<a *ngIf="this.mainService.valePresenteCestaService.itens.length" (click)="router.navigate(['/valepresente/cesta'])"
    id="minhaCesta" class="btn app-btn-best-v2"  style="margin-bottom: 50px;">
    <i class="fa fa-shopping-basket"></i> Minha Cesta
</a>

<div *ngIf="mainService.valePresenteService.processando" class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<input id="length-tabela-vale-presente" type="hidden" value="{{mainService.valePresenteService.pedidos?.length}}">

<div *ngIf="mainService.valePresenteService.pedidos !== undefined && mainService.valePresenteService.pedidos.length > 0" style="margin-bottom: 100px;"
    class="table-responsive">
    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th>Pedido</th>
                <th><span class="glyphicon glyphicon-arrow-down"></span>Data</th>
                <th>Pontos</th>
                <th>Frete</th>
                <th>Status</th>
                <th>Código de Rastreio</th>
                <th>Ações</th>
            </tr>
        </thead>
        <tbody id="tabelaValeBody">
            <tr *ngFor="let pedido of mainService.valePresenteService.pedidos">
                <td>{{ pedido.id }}</td>
                <td>{{ pedido.solicitacao| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ pedido.valorPontos }}</td>
                <td>{{ pedido.frete.pontos }}</td>
                <td>{{ pedido.status.replace("_", " ") }}</td>
                <td>{{ pedido.codigoRastreio }}</td>
                <td>
                    <button (click)="mainService.valePresenteService.visualizarPedido(pedido)" class="btn app-btn-best">
                        <i class="fa fa-eye"></i> visualizar
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>


// WEBPACK FOOTER //
// ./src/app/vale-presente/vale-presente.component.html